import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Lenis from "lenis";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import StickyBar from "@/components/StickyBar";
import Home from "@/pages/Home";
import ServicesIndex from "@/pages/ServicesIndex";
import ServicePage from "@/pages/ServicePage";
import LocationsIndex from "@/pages/LocationsIndex";
import CityPage from "@/pages/CityPage";
import CityServicePage from "@/pages/CityServicePage";
import ResourcesIndex from "@/pages/ResourcesIndex";
import ArticlePage from "@/pages/ArticlePage";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";

function ScrollManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ autoRaf: true, duration: 1.1 });
    return () => lenis.destroy();
  }, []);

  return (
    <div className="App grain min-h-screen bg-ink text-foreground">
      <HelmetProvider>
        <BrowserRouter>
          <ScrollManager />
          <Header />
          <main className="pt-[62px] sm:pt-[66px]">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<ServicesIndex />} />
              <Route path="/services/:slug" element={<ServicePage />} />
              <Route path="/locations" element={<LocationsIndex />} />
              <Route path="/locations/:slug" element={<CityPage />} />
              <Route path="/locations/:citySlug/:serviceSlug" element={<CityServicePage />} />
              <Route path="/resources" element={<ResourcesIndex />} />
              <Route path="/resources/:slug" element={<ArticlePage />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
          <div className="h-14" aria-hidden="true"></div>
          <StickyBar />
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
